interface SleepStageBarProps {
  deepMinutes: number;
  remMinutes: number;
  coreMinutes: number;
  awakeMinutes: number;
}

const STAGES: Array<{ key: keyof SleepStageBarProps; label: string; color: string }> = [
  { key: 'deepMinutes', label: 'Profundo', color: 'var(--vt-accent-2)' },
  { key: 'remMinutes', label: 'REM', color: 'var(--vt-accent)' },
  { key: 'coreMinutes', label: 'Ligero', color: 'var(--vt-surface-muted)' },
  { key: 'awakeMinutes', label: 'Despierto', color: 'var(--vt-down)' },
];

export function SleepStageBar(props: SleepStageBarProps) {
  const total = props.deepMinutes + props.remMinutes + props.coreMinutes + props.awakeMinutes || 1;

  return (
    <div className="sleep-stage-bar">
      <div className="sleep-stage-bar__track">
        {STAGES.map(({ key, color }) => {
          const value = props[key];
          const widthPercent = (value / total) * 100;
          return (
            <div
              key={key}
              className="sleep-stage-bar__segment"
              style={{ width: `${widthPercent}%`, backgroundColor: color }}
            />
          );
        })}
      </div>
      <div className="sleep-stage-bar__legend">
        {STAGES.map(({ key, label, color }) => (
          <div key={key} className="sleep-stage-bar__legend-item">
            <span className="sleep-stage-bar__dot" style={{ backgroundColor: color }} />
            <span>{label}</span>
            <span className="sleep-stage-bar__legend-value">{Math.round(props[key])} min</span>
          </div>
        ))}
      </div>
    </div>
  );
}
